import { render, staticRenderFns } from "./reservationVirtual.vue?vue&type=template&id=f9930804&"
import script from "./reservationVirtual.vue?vue&type=script&lang=js&"
export * from "./reservationVirtual.vue?vue&type=script&lang=js&"
import style0 from "./reservationVirtual.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports